// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2yh0Z","title":"Header_title__37_Rd","left":"Header_left__1GUds","clinicName":"Header_clinicName__2Wp-2"};